import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Chip, Divider, IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreDialog from "../../../../app/core/components/CoreDialog/CoreDialog";
import CorePagination from "../../../../app/core/components/CorePagination/CorePagination";
import { formatItalianDate } from "../../../../utils/functions/date-utils";
import {
  useDeleteNewsMutation,
  useEditNewsMutation,
  usePublishNewsMutation,
} from "../../../api/admin/gestioneNewsApi";
import { renderText } from "../../../../utils/functions/textFormatter";
import StopCircleIcon from "@mui/icons-material/StopCircle";

const TableNews = ({ news, setPage, page, isLoading, totalPages }) => {
  const navigate = useNavigate();
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [singleNews, setSingleNews] = useState();

  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);

  const [deleteNews, { isLoading: isDeleteLoading }] = useDeleteNewsMutation();
  const [publishNews, { isLoading: isLoadingPublish }] =
    usePublishNewsMutation();
  const [editNews, { isLoading: isEditLoading }] = useEditNewsMutation();

  const handlePublichNews = (id) => {
    publishNews(id)
      .then((res) => {
        if (res.data.Data && !res.data.Exception)
          toast.success(t("NewsPublished"));
        else toast.error(t("NewsNotPublished"));
      })
      .catch(() => {
        toast.error(t("NewsNotPublished"));
      });
  };

  const handleStopNews = (el) => {
    const bodyDataNews = {
      ...el,
      Id: el.id,
      status: 0,
    };

    editNews(bodyDataNews)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(t("NewsNotUpdated"));
          return;
        }
        toast.success(t("NewsUpdated"));
      })
      .catch(() => toast.error(t("NewsNotUpdated")));
  };

  const handleConfermDialog = () => {
    deleteNews(singleNews.id)
      .then((res) => {
        if (res.data.Data && !res.data.Exception) {
          toast.success(t("NewsDeleted"));
          setShowConfirmUserDialog(false);
        } else toast.error(t("NewsNotDeleted"));
      })
      .catch(() => {
        toast.error(t("NewsNotDeleted"));
      });
  };

  function getFirstTwoLines(text) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = text;
    const plainText = tempElement.innerText;
    const firstTwoLines = plainText.substring(0, 80);
    return firstTwoLines;
  }

  const handleDeleteNews = (news) => {
    setSingleNews(news);
    setShowConfirmUserDialog(true);
  };

  const handleCloseDialod = () => {
    setShowConfirmUserDialog(false);
  };

  return (
    <div className="w-full p-4">
      {news?.map((el, index) => (
        <div key={index}>
          <div className="flex py-8 items-center space-x-12">
            <div className="flex w-28 h-28 items-center text-center">
              <img
                src={el.imageUrl ? el.imageUrl : "/img/placeholder-image.svg"}
                alt="Immagine"
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </div>
            <div className="w-7/12">
              <div className="flex items-center space-x-8">
                <h3>{el.title}</h3>
                <div className="space-x-2 ">
                  <Chip
                    style={{
                      color: colorPrimary,
                      borderColor: colorPrimary,
                    }}
                    variant="outlined"
                    label={
                      "Destinatari:" +
                      " " +
                      (el.employmentStatusName
                        ? el.employmentStatusName
                        : t("All"))
                    }
                    size="small"
                  />
                </div>
              </div>

              <div className="m-0">{renderText(el.text)}</div>
              <small
                className="font-semibold   "
                style={{ color: colorPrimary }}
              >
                creata il: {formatItalianDate(el.createdAt)}
              </small>
            </div>{" "}
            <div className="w-2/12 flex justify-center">
              <Tooltip title={t("Edit")}>
                <IconButton
                  className="w-10 h-10"
                  onClick={() => navigate(el.id)}
                >
                  <EditRoundedIcon className="w-full h-full" />
                </IconButton>
              </Tooltip>
              {el.status === 0 ? (
                <Tooltip title={t("Publish")}>
                  <IconButton
                    className="w-10 h-10"
                    onClick={() => handlePublichNews(el.id)}
                  >
                    <PlayArrowRoundedIcon className="text-green-600" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={t("Cancel")}>
                  <IconButton
                    className="w-10 h-10"
                    onClick={() => handleStopNews(el)}
                  >
                    <StopCircleIcon className="text-yellow-500" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title={t("Delete")}>
                <IconButton
                  className="w-10 h-10"
                  onClick={() => handleDeleteNews(el)}
                >
                  <DeleteRoundedIcon
                    fontSize="small"
                    className="text-rose-700"
                  />
                </IconButton>
              </Tooltip>
            </div>
            <div className="w-1/12">
              <p className="font-bold">Stato</p>
              <small
                className={
                  el.status === 1
                    ? "text-green-600 font-semibold "
                    : "text-yellow-500 font-semibold "
                }
              >
                {el.status === 1 ? t("Published") : t("Draft")}
              </small>
            </div>
          </div>
          <Divider />
        </div>
      ))}
      <div className="w-full flex justify-center">
        <CorePagination page={page} setPage={setPage} totalPages={totalPages} />
      </div>

      <CoreDialog
        open={showConfirmUserDialog}
        title={`${t("Delete")} ${t("news")}`}
        content={`${t("NewsDeletingConfirm")} '${singleNews?.title}'?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDialod}
      />
    </div>
  );
};

export default TableNews;
